import { Component } from '@angular/core';

@Component({
  selector: 'ngx-ecole',
  template: `<router-outlet></router-outlet>`,
})
export class EcoleComponent {
}
